import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { createCookiesH3Component } from '../../utils/markdownUtils'
import './MarkdownPage.css'

const { Title } = Typography

interface MarkdownPageProps {
    text: {
        title: string
        content: string
    }
    titleKey?: string
}

const MarkdownPage = ({ text, titleKey }: MarkdownPageProps) => {
    const { t } = useTranslation()
    const displayTitle = titleKey ? t(titleKey) : text.title

    return (
        <div className="main-content">
            <Title className="title privacy" level={2}>
                {displayTitle}
            </Title>
            <Markdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h3: createCookiesH3Component(),
                }}
            >
                {text.content}
            </Markdown>
        </div>
    )
}

export default MarkdownPage
